import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Layout from './components/Layout';
import ThemeProvider from './theme/ThemeProvider';
import PageTransition from './components/motion/PageTransition';
import Home from './pages/Home';
import Sets from './pages/Sets';
import SetDetail from './pages/SetDetail';
import MyMrBoss from './pages/MyMrBoss';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Contact from './pages/Contact';
import About from './pages/About';
import Admin from './pages/Admin';
import AdminLogin from './pages/AdminLogin';
import { PaymentSuccess, PaymentCancel } from './pages/Payment';
import { AdminAuthProvider, useAdminAuth } from './context/AdminAuthContext';

function ProtectedAdminRoute({ children }) {
  const { adminUser } = useAdminAuth();
  if (adminUser === null) return null;
  if (adminUser === false) return <Navigate to="/admin/login" replace />;
  return children;
}

const LayoutRoutes = () => {
  const location = useLocation();
  return (
    <Layout>
      <AnimatePresence mode="wait" initial={false}>
        <PageTransition key={location.pathname}>
          <Routes location={location}>
            <Route path="/" element={<Home />} />
            <Route path="/sets" element={<Sets />} />
            <Route path="/sets/my-mr-boss" element={<MyMrBoss />} />
            <Route path="/sets/:slug" element={<SetDetail />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:slug" element={<ProductDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/admin" element={
              <ProtectedAdminRoute>
                <Admin />
              </ProtectedAdminRoute>
            } />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </PageTransition>
      </AnimatePresence>
    </Layout>
  );
};

function AppRoutes() {
  const location = useLocation();
  if (location.pathname === '/admin/login') {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
      </Routes>
    );
  }
  return <LayoutRoutes />;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AdminAuthProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </AdminAuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
